import { render, staticRenderFns } from "./day.vue?vue&type=template&id=2ec004db&scoped=true&"
import script from "./day.vue?vue&type=script&lang=js&"
export * from "./day.vue?vue&type=script&lang=js&"
import style0 from "./day.vue?vue&type=style&index=0&id=2ec004db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec004db",
  null
  
)

export default component.exports